class PredictiveSearchArticles extends HTMLElement {
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.resultsContainer = this.querySelector("#predictive-search-articles");
		this.defaultContainer = this.querySelector("#predictive-search-articles-default");

		this.form = this.querySelector('form');
		if (this.form) {
		  this.form.addEventListener('submit', (e) => {
		    e.preventDefault();
		  });
		}

		this.input.addEventListener(
			"input",
			this.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);
	}

	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		// On cible uniquement les articles
		fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=article&section_id=predictive-search-articles`)
			.then((response) => {
				if (!response.ok) {
					this.close();
					throw new Error(response.status);
				}
				return response.text();
			})
			.then((text) => {
				const doc = new DOMParser().parseFromString(text, "text/html");
				const resultsMarkup = doc.querySelector("#shopify-section-predictive-search-articles")?.innerHTML || "";
				this.resultsContainer.innerHTML = resultsMarkup;
				this.open();
				this.addBackdropListener();
			})
			.catch(() => {
				this.close();
			});
	}

	open() {
		this.resultsContainer.style.display = "block";
		this.defaultContainer.style.display = "none";
		const backdrop = this.querySelector(".mm-predictive-search-articles-backdrop");
		if (backdrop) backdrop.style.display = "block";
	}

	close() {
		this.resultsContainer.style.display = "none";
		this.defaultContainer.style.display = "flex";
		const backdrop = this.querySelector(".mm-predictive-search-articles-backdrop");
		if (backdrop) backdrop.style.display = "none";
	}

	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}

	addBackdropListener() {
		const backdrop = this.querySelector(".mm-predictive-search-articles-backdrop");
		if (backdrop) {
			backdrop.addEventListener("click", () => this.close());
		}
	}
}

customElements.define("predictive-search-articles", PredictiveSearchArticles);
